import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { App } from './App';
import { store } from './store';
import { WidgetParamsProvider } from './WidgetPropsContext';

import './styles/index.scss';
import './utils/polyfills';

// Preload BYN → ₽ ligature font at startup to avoid FOIT when prices appear
if (document.fonts?.load) {
    document.fonts.load('1em nbrb', 'BYN');
}

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <Router>
                <WidgetParamsProvider>
                    <App />
                </WidgetParamsProvider>
            </Router>
        </Provider>
    </React.StrictMode>,
    // eslint-disable-next-line no-undef
    document.getElementById('root'),
);
